import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Email\SendEmailController::__invoke
* @see app/Http/Controllers/Email/SendEmailController.php
* @route '/api/notification/send-email'
*/
const SendEmailController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendEmailController.url(options),
    method: 'post',
})

SendEmailController.definition = {
    methods: ["post"],
    url: '/api/notification/send-email',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Email\SendEmailController::__invoke
* @see app/Http/Controllers/Email/SendEmailController.php
* @route '/api/notification/send-email'
*/
SendEmailController.url = (options?: RouteQueryOptions) => {
    return SendEmailController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Email\SendEmailController::__invoke
* @see app/Http/Controllers/Email/SendEmailController.php
* @route '/api/notification/send-email'
*/
SendEmailController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendEmailController.url(options),
    method: 'post',
})

export default SendEmailController